// show-password directive
// <input type=password show-password="showPassword" ng-model="thePassword">

let module = angular.module('app.directives');

module.directive('showPassword', function () {
  return {
    restrict: 'A',
    link: function (scope, elem, attrs) {
      scope.$watch(attrs.showPassword, function (newValue) {
        if (newValue) {
          elem.attr('type', 'text');
        } else {
          elem.attr('type', 'password');
        }
      });
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/show-password.js